
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"12","cy":"12","r":"11.25","stroke":"#FD6482","stroke-width":"1.5"}}),_c('path',{attrs:{"stroke-width":"2","d":"M19.979 9.824a.442.442 0 00-.357-.3l-4.993-.726-2.233-4.524c-.149-.302-.644-.302-.792 0L9.371 8.798l-4.993.726a.442.442 0 00-.245.753l3.613 3.522-.852 4.973a.441.441 0 00.64.465L12 16.889l4.466 2.348a.44.44 0 00.64-.465l-.853-4.973 3.614-3.522a.442.442 0 00.111-.453zM15.47 13.33a.441.441 0 00-.127.39l.74 4.32L12.207 16a.44.44 0 00-.412 0l-3.879 2.04.74-4.32a.441.441 0 00-.126-.39l-3.138-3.06 4.337-.63a.44.44 0 00.332-.242L12 5.467l1.94 3.93a.44.44 0 00.332.242l4.338.63-3.139 3.06z","stroke":"#FD6482","fill":"#FD6482"}})])
          )
        }
      }
    